import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import {getToken} from '../../../storage'
import { removeZeros} from '../../../utils/misc'
import {API_BASE_URL} from '../../../constants'
import {AddItemModal} from '../../modal/modal'

export default class BarcodeElement extends React.Component {
  constructor() {
    super();
    this.state = {
      value: '',
      showItemCreate:false,
    };
  }

  static defaultProps = {
    maxDelay: 500
  }

  componentWillReceiveProps(nextProps) {
   if (nextProps.item !== this.props.item) {
     //Forcibly overwrite input value to new default if the default ever changes
     let item = nextProps.item

     if(item) {
       if(item.serial_barcode) {
         this.setState({value:item.serial_barcode})
       }
       else if(item.serial > 0) {
          this.setState({value:item.serial})
       }

     }
     else {
       this.setState({value:''})
     }
   }
 }

  componentDidMount() {
    let item = this.props.item
    if(item) {
      if(item.serial_barcode) {
        this.setState({value:item.serial_barcode})
      }
      else if(item.serial > 0) {
         this.setState({value:item.serial})
      }
    }
  }

  lastTime = 0

  handleInputChange = (e) => {
    const { maxDelay } = this.props
    const now = Date.now()
    const delay = now - this.lastTime
    const value = e.target.value

    if (delay <= maxDelay || this.lastTime === 0) {
      this.setState(() => ({
        value: value
      }))

      this.lastTime = now
      setTimeout(() => {
        if (this.state.value.length < 2) this.clearValue()
      }, maxDelay * 2)

      return null
    }

    if (delay > maxDelay) this.clearValue()
  }

  clearValue = () => {
    this.setState(() => ({
      value: ''
    }))
    this.resetLastTime()
  }

  handleChange = (item)=>{

    if(item) {
      this.setState({value:item.serial_barcode ? item.serial_barcode: item.serial})
      const i = {
        serial:item.serial,
        serial_barcode:item.serial_barcode,
        item:item.id,
        name: item.name,
        batch:{},
        hsn: item.hsn,
        quantity:1,
        tableIndex: this.props.item.tableIndex,
        mrp: parseFloat(item.mrp),
        discounts: item.discounts,
        selling_basic_rate: parseFloat(item.selling_basic_rate),
        purchase_basic_rate: parseFloat(item.purchase_basic_rate),
        selling_rate: parseFloat(item.selling_rate),
        price: parseFloat(item.selling_rate),
        gst: item.gst,
        cgst_amount: parseFloat(item.cgst_amount), sgst_amount: parseFloat(item.sgst_amount), igst_amount: parseFloat(item.igst_amount),
        total: parseFloat(item.selling_rate),
        discount_value: 0
       }
       this.props.onAddCallback(i)
       this.setState({showItemCreate:false})
    }

  }

  handleItemModal = ()=> {
    this.setState({
      showItemCreate:false
    })
  }

  handleInputKeyUp = (e) => {
    const keyCode = e.keyCode
    if (keyCode === 8) {
      this.setState({
        value: ''
      })

      this.resetLastTime()
    }

    if (keyCode === 13) {
      // Handle Enter
      let items = this.props.items


      let item = items.find((item)=>{return (item.serial_barcode ? item.serial_barcode: ""+item.serial)===this.state.value})

      if(item) {

        const i = {
          serial:item.serial,
          serial_barcode:item.serial_barcode,
          item:item.id,
          name: item.name,
          batch:{},
          hsn: item.hsn,
          quantity:1,
          tableIndex: this.props.item.tableIndex,
          mrp: parseFloat(item.mrp),
          discounts: item.discounts,
          selling_basic_rate: this.props.purchase ? 0 : parseFloat(item.selling_basic_rate),
          purchase_basic_rate:this.props.purchase ? 0 : parseFloat(item.purchase_basic_rate),
          selling_rate:this.props.purchase ? 0 : parseFloat(item.selling_rate),
          price:this.props.purchase ? 0 : parseFloat(item.selling_rate),
          gst: item.gst,
          cgst_amount: parseFloat(item.cgst_amount), sgst_amount: parseFloat(item.sgst_amount), igst_amount: parseFloat(item.igst_amount),
          total: parseFloat(item.selling_rate),
          discount_value: 0
         }

         let ll = item.serial_barcode ? item.serial_barcode: item.serial
         this.setState({value:ll})
         this.props.onAddCallback(i)

      }
      else {
        
        this.setState({showItemCreate:true})
      }
      this.resetLastTime()
    }
  }

  resetLastTime = () => {
    this.lastTime = 0
    this.input.select()
  }

  render() {

    let modal = <AddItemModal show={this.state.showItemCreate} handleModalToggle={this.handleItemModal} onAddCallback={this.handleChange} />

    const { value } = this.state
    console.log(value);
    return (
      <div>
        {modal}
        <input className="form-control" autoFocus
          ref={input => this.input = input}
          value={value}
          onChange={this.handleInputChange}
          onKeyUp={this.handleInputKeyUp}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/invoice/rowelements/barcodeelement.js